/** API uses `type`; some payloads used `actions` for the action kind. */
export default function isWeblinkAction(defaultAction) {
  if (!defaultAction) return false
  const kind = defaultAction.type ?? defaultAction.actions
  if (kind && String(kind).toUpperCase() === 'WEBLINK') return true
  const url = defaultAction.url
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim())
}
